const ribbon = "_uihrk8hhjt";

export { ribbon };
import "./atom.ribbon.style.linaria.module.css";
//# sourceMappingURL=atom.ribbon.style.js.map
